export default __webpack_public_path__ + "swim-safety-blue-swim-light.svg";